// Money stays in integer paise during arithmetic. Existing Number fields remain
// rupees at the storage/API boundary; no historical value is rounded here.
function invalid(label, status, detail) {
  return Object.assign(new Error(`${label}: ${detail}`), { status });
}
function checkedPaise(value, label = 'INR amount', status = 400) {
  if (!Number.isSafeInteger(value) || value < 0) throw invalid(label, status, 'amount exceeds the safe integer-paise range');
  return value;
}
function toPaise(value, label = 'INR amount', status = 400) {
  if (!['number', 'string'].includes(typeof value) || (typeof value === 'number' && !Number.isFinite(value))) {
    throw invalid(label, status, 'a finite INR amount with at most two decimal places is required');
  }
  const match = /^(\d+)(?:\.(\d{0,2}))?$/.exec(String(value).trim());
  if (!match) throw invalid(label, status, 'use a nonnegative INR amount with at most two decimal places; no automatic rounding');
  return checkedPaise(Number(match[1]) * 100 + Number((match[2] || '').padEnd(2, '0')), label, status);
}
function fromPaise(paise, label = 'INR amount', status = 400) {
  checkedPaise(paise, label, status);
  const amount = paise / 100;
  if (toPaise(amount, label, status) !== paise) throw invalid(label, status, 'cannot be represented exactly at the rupee storage boundary');
  return amount;
}
function sumPaise(values, label = 'INR total', status = 400) {
  return values.reduce((sum, value) => checkedPaise(sum + checkedPaise(value, label, status), label, status), 0);
}
function invoicePaise(items, discount = 0) {
  const gross = sumPaise(items.map(item => {
    if (!Number.isSafeInteger(item.qty) || item.qty < 1) throw invalid('Ordered quantity', 400, 'a positive whole number is required');
    return checkedPaise(toPaise(item.amount, 'Unit price') * item.qty, 'Line amount');
  }));
  return { gross, total: Math.max(gross - toPaise(discount, 'Discount'), 0) };
}
function sumRupees(values, legacyReadOnly = false) {
  try { return fromPaise(sumPaise(values.map(value => toPaise(value)))); }
  catch (error) {
    if (!legacyReadOnly) throw error;
    return values.reduce((sum, value) => sum + Number(value), 0);
  }
}
function multiplyRupees(amount, qty, legacyReadOnly = false) {
  try {
    if (!Number.isSafeInteger(qty) || qty < 0) throw invalid('Quantity', 400, 'a nonnegative whole number is required');
    return fromPaise(checkedPaise(toPaise(amount) * qty));
  } catch (error) {
    if (!legacyReadOnly) throw error;
    return Number(amount) * qty;
  }
}
module.exports = { toPaise, fromPaise, checkedPaise, sumPaise, invoicePaise, sumRupees, multiplyRupees };
